module.exports = __webpack_public_path__ + "static/img/shiye.309a5adc.png";